import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';

// A small confirmation dialog that collects a reason (reject / cancel / reverse). Enter submits; Escape closes.
export function ReasonDialog({ open, title, message, confirmLabel, reasonRequired = true, busy, onClose, onConfirm }: {
  open: boolean; title: string; message?: string; confirmLabel: string; reasonRequired?: boolean; busy?: boolean;
  onClose: () => void; onConfirm: (reason: string) => void;
}) {
  const [reason, setReason] = useState('');
  useEffect(() => { if (open) setReason(''); }, [open]);
  const blocked = busy || (reasonRequired && !reason.trim());
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <form onSubmit={(e) => { e.preventDefault(); if (!blocked) onConfirm(reason.trim()); }}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {message && <DialogContentText sx={{ mb: 1.5 }}>{message}</DialogContentText>}
          <TextField autoFocus fullWidth multiline minRows={2} size="small" label={reasonRequired ? 'Reason (required)' : 'Reason'} value={reason}
            onChange={(e) => setReason(e.target.value)} InputLabelProps={{ shrink: true }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Back</Button>
          <Button type="submit" variant="contained" disabled={blocked}>{confirmLabel}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
